import { render, staticRenderFns } from "./VideoSidebar.vue?vue&type=template&id=a2a4036c&scoped=true"
import script from "./VideoSidebar.vue?vue&type=script&lang=js"
export * from "./VideoSidebar.vue?vue&type=script&lang=js"
import style0 from "./VideoSidebar.vue?vue&type=style&index=0&id=a2a4036c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a4036c",
  null
  
)

export default component.exports